module.exports = __webpack_public_path__ + "54dd57a3.png";